import { render, staticRenderFns } from "./PieChartV2.vue?vue&type=template&id=b5680e7c&scoped=true"
import script from "./PieChartV2.vue?vue&type=script&lang=js"
export * from "./PieChartV2.vue?vue&type=script&lang=js"
import style0 from "./PieChartV2.vue?vue&type=style&index=0&id=b5680e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5680e7c",
  null
  
)

export default component.exports